module.exports = __webpack_public_path__ + "static/media/icons-ic-nscb-transfer.ea721df8.svg";